import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IEventSpace } from "../eventspaceModal";

export const getAllEventSpace = createAsyncThunk(
  "EventSpace/FindAllEventSpace",
  async (filters: { EventSpaceTitle: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/FindAllEventSpace`,
        filters,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching EventSpace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createEventSpace = createAsyncThunk(
  "EventSpace/InsertEventSpace",
  async (EventSpaceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/InsertEventSpace`,
        EventSpaceData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating EventSpace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateEventSpace = createAsyncThunk(
  "EventSpace/UpdateEventSpace",
  async (EventSpaceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/UpdateEventSpace`,
        EventSpaceData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating EventSpace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteEventSpace = createAsyncThunk(
  "EventSpace/DeleteEventSpace",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/DeleteEventSpace`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting EventSpace :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getEventSpaceByID = createAsyncThunk(
  "EventSpace/FindByIDEventSpace",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/FindByIDEventSpace`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        Images: result.Images,
        IsActive: result.IsActive ? 1 : 2,
      } as IEventSpace;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching EventSpace :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveEventSpace = createAsyncThunk(
  "EventSpace/FindAllActiveEventSpace",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/FindAllActiveEventSpace`,
        {},
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active EventSpace:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveEventSpace = createAsyncThunk(
  "EventSpace/ActiveInActiveEventSpace",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/ActiveInActiveEventSpace`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive EventSpace :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const EventSpaceImageUpload = createAsyncThunk(
  "EventSpace/EventSpaceImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EventSpace/EventSpaceImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload EventSpace Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
